<app-custom-select
    [data]="status"
    [selected]="selected"
    [selectLabel]="typeSelect"
    (selectedChange)="change($event)"
></app-custom-select>